
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"67","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.937 12.44l17.464 8.438 4.314 18.96-12.086 15.204H24.246L12.16 39.838l4.313-18.96z","fill":"#71d3b9"}}),_c('g',{attrs:{"transform":"rotate(-26 33.5 35)"}},[_c('path',{attrs:{"d":"M33.017 16l14.416 6.942 3.542 15.636-9.998 12.556-16.01.02L15 38.625l3.583-15.645z","fill":"#0a294a"}})]),_c('g',[_c('path',{attrs:{"d":"M30.234 29.585a7.566 7.566 0 010-1.306c.022-.428.122-.849.294-1.241.164-.374.377-.724.635-1.042.258-.307.582-.553.948-.72a3.35 3.35 0 011.365-.274 3.017 3.017 0 012.058.71 3.456 3.456 0 011.11 1.733c.182.699.217 1.428.103 2.14 0 .057.01.133 0 .237-.01.104-.057.294-.123.578a6.814 6.814 0 01-.246.814 5.84 5.84 0 01-.456.91 4.119 4.119 0 01-.578.823c-.228.24-.498.436-.796.578-.32.14-.666.207-1.015.199a2.43 2.43 0 01-1.062-.2 2.398 2.398 0 01-.834-.624 5.01 5.01 0 01-.569-.805 4.117 4.117 0 01-.417-.88c-.104-.294-.19-.56-.256-.806s-.142-.435-.142-.596zM25 40.088c.114-.873.276-1.74.484-2.595a5.553 5.553 0 011.962-2.017 5.068 5.068 0 012.73-.786l2.74 1.723c.359.232.819.232 1.177 0l2.692-1.8c.95.006 1.88.285 2.674.806a6.272 6.272 0 012.02 2.121c.223.86.397 1.733.521 2.614-1.925 2.547-15.104 2.538-17-.066z","fill":"#fff"}})])])
          )
        }
      }
    